import { TabPanel } from '@mui/lab'
import React, { Component } from 'react'
import { SUPPORT_TAB } from '../SupportOverview'
import { Typography } from '@mui/material'
import { connect } from 'react-redux'
import SupportCaseButton from '../Elements/SupportCaseButton'

export class ClosedSupportCasesTabContent extends Component {
    render() {
        return (
            <TabPanel value={SUPPORT_TAB.CLOSED.toString()}>
                <Typography>Geschlossene Supportfälle</Typography>
                <div style={{ display:"flex", flexWrap:"wrap", justifyContent:"center", marginTop:"2.5%"}}>
                    {this.props.caseList?.map(item => {
                        return <SupportCaseButton key={"SupporCaseBtn_"+item.id} id={item.id}  data={item}></SupportCaseButton>
                    })}
                </div>
            </TabPanel>
        )
    }
}
function mapStateToProps(state) {
    return {
        caseList: state.support.closedCaseList
    }
}
export default connect(mapStateToProps)( ClosedSupportCasesTabContent)
